var map = {
	"./diagnostico.js": "wt/0",
	"./index.js": "PsNR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ycNj";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/diagnostico nonrecursive \.js$
// module id = ycNj
// module chunks = 11